import { Form, type InferType, useForm, yup, yupResolver } from 'form';
import { ConfirmationButton } from 'ui';

import { TradeCompanySiteMaterialPicker } from '../../../site-material';

const schema = yup.object().shape({
  trade_company: yup.string(),
  trade_company_site_material: yup.string(),
});

export type SampleMaterialEditFormValues = InferType<typeof schema>;

export const SampleMaterialEditForm = ({ onSubmit }: { onSubmit: (data: SampleMaterialEditFormValues) => void }) => {
  const form = useForm({ resolver: yupResolver(schema) });
  return (
    <Form {...form}>
      <TradeCompanySiteMaterialPicker />

      <ConfirmationButton
        title="Warning!"
        message="You are about to change this evidence. This will remove it from the associated quality report. Please confirm to continue."
        onConfirm={form.handleSubmit(onSubmit)}
      >
        Edit
      </ConfirmationButton>
    </Form>
  );
};
